export enum RedirectionLinks {
  TERMS_OF_USE_LINK = "https://smartcommerce.amazon.in/terms-of-use",
  PRIVACY_POLICY_LINK = "https://smartcommerce.amazon.in/privacy-policy",
  SELLER_APP_GOOGLE_PLAY_STORE = "https://play.google.com/store/apps/details?id=com.amazon.sft.rangoli.seller.app",
  FAQ = "https://help.smartbiz.in/hc/en-us/sections/18491586242321-FAQs"
}